import React, { useContext } from "react";
import { DataTable, ErrorBoundary, Page, hasActiveFilters, } from "@sscs/ui";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../../store/mlbomSlice";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetModelCardsQuery } from "../../services/mlbom.api";
import { useGetReportSummaryQuery } from "../../services/shared.api";
import { getQueryStatus } from "../../utils";
import XbomExportActions from "../common/XbomExportActions/XbomExportActions";
import Filter from "./Filter/Filter";
import MLModel from "./MLModel/MLModel";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "publisher",
        label: "Publisher",
        sortProperty: "publisher",
        sortId: "mlbom-sort-publisher",
        width: "250px",
    },
    {
        id: "product",
        label: "Name and version",
        sortProperty: "product",
        sortId: "mlbom-sort-product",
        width: "50%",
    },
    {
        id: "architecture",
        label: "Model architecture",
        sortProperty: "type",
        sortId: "mlbom-sort-architecture",
        width: "50%",
    },
    {
        id: "task",
        label: "Task",
        sortProperty: "task",
        sortId: "mlbom-sort-task",
        width: "180px",
    },
    {
        id: "license",
        label: "License",
        sortProperty: "license",
        sortId: "mlbom-sort-license",
        width: "250px",
    },
    {
        id: "component_count",
        label: "# Components",
        sortProperty: "component_count",
        sortId: "mlbom-sort-component-count",
        startReverse: true,
        width: "170px",
    },
];
const MLBOMContent = () => {
    var _a;
    const dispatch = useReportDispatch();
    const { diffId, reportId } = useContext(ReportContext);
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        ui_id: reportId,
        diff_report_id: diffId,
    });
    const { data = { match_count: 0, model_cards: [] }, isLoading, isFetching, isError, error, } = useGetModelCardsQuery({
        ui_id: reportId,
        filter,
        sort,
        pagination,
    });
    const handleSortChange = (newSort) => {
        dispatch(sortUpdated(newSort));
    };
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: "Machine learning bill of materials", details: [
                `${((_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.xbom.mlbom) !== null && _a !== void 0 ? _a : 0).toLocaleString()} Machine learning models`,
            ], actions: React.createElement(XbomExportActions, null) }),
        React.createElement(Page.Filters, { found: {
                id: "mlbom-clear-all-filters",
                count: data.match_count,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, onFilterChange: (newFilter) => dispatch(filterUpdated(newFilter)) })),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "machine learning models",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => dispatch(filterUpdated(initFilter)),
                    },
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data,
                }), pagination: {
                    id: "mlbom-pagination",
                    itemCount: data.match_count,
                    pagination,
                    onChange: (pagination) => dispatch(paginationUpdated(pagination)),
                } }, data.model_cards.map((modelCard, index) => (React.createElement(MLModel, { key: modelCard.id, modelCard: modelCard, rowIndex: index })))))));
};
const MLBOM = () => {
    return (React.createElement(ErrorBoundary, { key: "mlbom" },
        React.createElement(MLBOMContent, null)));
};
export default MLBOM;
//# sourceMappingURL=MLBOM.js.map